import type { IconType } from "@circle-react/components/shared/Icon";
import { Icon } from "@circle-react/components/shared/Icon";
import { Link } from "@tanstack/react-router";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import { useGetSidebarLinkClass } from "../CommunityMenu/SpaceList/useGetSidebarLinkClass";
import { SidebarBadge } from "./SidebarBadge";

export interface PlatformMenuItemLinkProps {
  badgeText?: string;
  dataTestId?: string;
  disabled?: boolean;
  iconName: IconType;
  isActive?: boolean;
  isGrayBadge?: boolean;
  label: string;
  linkTo: string;
  show?: boolean;
}

export const PlatformMenuItemLink = ({
  badgeText,
  isGrayBadge = false,
  show = true,
  dataTestId,
  iconName,
  label,
  linkTo,
  disabled = false,
  isActive = false,
}: PlatformMenuItemLinkProps) => {
  const { getActiveInactiveClasses } = useGetSidebarLinkClass();
  const { currentCommunity, currentCommunityMember } = usePunditUserContext();

  if (!show) {
    return null;
  }

  return (
    <Link
      data-testid={dataTestId}
      to={linkTo}
      className="my-px flex w-full cursor-pointer items-center px-2 py-1.5 text-sm"
      activeProps={{
        className: getActiveInactiveClasses(true),
      }}
      inactiveProps={{
        className: getActiveInactiveClasses(isActive),
      }}
      onClick={event => {
        if (disabled) {
          event.preventDefault();
          return;
        }
        if (!currentCommunityMember && currentCommunity?.is_private) {
          event.preventDefault();
          window.location.assign(linkTo);
        }
      }}
      title={label}
    >
      <Icon type={iconName} size={16} aria-hidden />
      <div className="ml-2 flex-1">
        <h3 className="max-w-full truncate text-sm font-normal text-current">
          {label}
        </h3>
      </div>
      {badgeText && (
        <SidebarBadge isGray={isGrayBadge}>{badgeText}</SidebarBadge>
      )}
    </Link>
  );
};
